module.exports = __webpack_public_path__ + "img/pro_two_6.2d214d22.jpg";